const apiHosts = {
  dev: "http://127.0.0.1:8848",
  qa: "https://access.qa.redhat.com/product-life-cycles/api",
  stage: "https://access.stage.redhat.com/product-life-cycles/api",
  beta: "https://lifecycle-api-stage.ext.us-east.aws.preprod.paas.redhat.com",
  prod: "https://access.redhat.com/product-life-cycles/api",
};

export default apiHosts;
